var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BPopover,{attrs:{"target":_vm.target,"triggers":"hover","boundary":"window","placement":_setup.popoverPlacement},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_setup.props.template.name))]},proxy:true}])},[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }